import { Text } from "@meditect/medibase-components";

export const SalesCannotRefundProformaSaleError = () => {
  return <Text>Un devis (proforma) n'a rien encaissé : il ne peut pas être remboursé.</Text>;
};
